export default { sha: 'e6dfa31da94e39f89e7c105162070a285fbcb19a', buildNumber: 'undefined' }
